import {Box, Stack, styled} from '@mui/material';

const StyledSubheader = styled(Box)`
	padding: 16px;
	background-color: ${({theme}) => theme.palette.primary.main};
`;

const StyledStack = styled(Stack)`
	height: 100%;
	padding: 16px;
	gap: 32px;
	background-color: ${({theme}) => theme.palette.grey[200]};
`;

export {StyledSubheader, StyledStack};
